// src/pages/ForgotPassword.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API_URL from "../config"; // ✅ Import de l’URL du backend
import "./ForgotPassword.css"; // fichier CSS séparé

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return alert("Veuillez entrer votre email");

    try {
      setLoading(true);
      const res = await axios.post(
        `${API_URL}/api/auth/forgot-password`,
        { email }
      );

      if (res.data.success) {
        alert("✅ Code envoyé à votre adresse email !");
        navigate("/verify-code", { state: { email } });
      } else {
        alert(res.data.message || "Erreur inconnue");
      }
    } catch (err) {
      console.error(err);
      alert("❌ Erreur serveur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-wrapper">
      <div className="forgot-card">
        <h1>Mot de passe oublié</h1>
        <p>Entrez votre email pour recevoir un code de vérification.</p>

        <form onSubmit={handleSubmit} className="forgot-form">
          <input
            type="email"
            placeholder="Votre email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" disabled={loading}>
            {loading ? "Envoi..." : "Envoyer le code"}
          </button>
        </form>

        <p className="back-login" onClick={() => navigate("/login")}>
          🔙 Retour à la connexion
        </p>
      </div>
    </div>
  );
}
